import api from '@/apis/cre/cRERepExportTaxListAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('cRERepExportTaxList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'cre_rep_export_list',
    field: {
      key: 'cre_rep_export_list_id',
      // code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataExportBCTC(context, payload) {
    return await api.getDataExportReport(payload || {});
  },

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async export(context, payload) {
    return await api.export(payload);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
